import { defineMessages } from 'react-intl';

export default defineMessages({
  pendingDocumentsTitle: {
    id: 'manager.documents_pending_validation_table.title',
  },
  validatedDocumentsTitle: {
    id: 'manager.validated_documents_table.title',
  },
  rejectedDocumentsTitle: {
    id: 'manager.rejected_documents_table.title',
  },
  claimNature: {
    id: 'manager.documents_table.table_header.claim_nature',
  },
  policyNumber: {
    id: 'manager.documents_table.table_header.policy_number',
  },
  registrationNumber: {
    id: 'manager.documents_table.table_header.registration_number',
  },
  vehiculeBrand: {
    id: 'manager.documents_table.table_header.vehicule_brand',
  },
  lossDate: {
    id: 'manager.documents_table.table_header.date_hour',
  },
  linesPerPage: {
    id: 'manager.documents_table.table.lines_per_page',
  },
  requiredDocumentsTitle: {
    id: 'manager.documents_table.table.required_documents.title',
  },
  requiredDocumentsSaveButton: {
    id:
      'manager.documents_pending_validation_page.table.required_documents.save_button',
  },
  requiredDocumentsDecisionYes: {
    id: 'manager.documents_pending_validation_page.decision.yes',
  },
  requiredDocumentsDecisionNo: {
    id: 'manager.documents_pending_validation_page.decision.no',
  },
  pendingDocumentsTabTitle: {
    id: 'manager_document_page.pending_validation_documents_tab_title',
  },
  validatedDocumentsTabTitle: {
    id: 'manager_document_page.validated_documents_tab_title',
  },
  rejectedDocumentsTabTitle: {
    id: 'manager_document_page.rejected_documents_tab_title',
  },
  validated: {
    id: 'manager_document_page.validated_status',
  },
  rejected: {
    id: 'manager_document_page.rejected_status',
  },
  toValidate: {
    id: 'manager_document_page.to_validate_status',
  },
  claimNumber: {
    id: 'manager.documents_table.table_header.claim_number',
  },
});
